import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import projects from '../assets/projects_data.json';
import '../assets/projectDetails.css';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';


import { skills_icons } from '../utils/icons';

const ProjectDetail: React.FC = () => {
  const { projectCategory, projectIndex } = useParams<{ projectCategory: string; projectIndex: string }>();
  const projectData = projects[projectCategory as keyof typeof projects]?.[Number(projectIndex)];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  if (!projectData) {
    return <div>Project not found</div>;
  }

  const images = [
    { src: projectData.thumbnail },
    ...(projectData.illustrations || []).map(illustration => ({ src: illustration }))
  ];

  return (
    <div className="project-detail">
      <h1>{projectData.title}</h1>
      <img 
        src={projectData.thumbnail} 
        alt={projectData.title} 
        className='thumbnail' 
        onClick={() => {
          setPhotoIndex(0);
          setIsOpen(true);
        }}
        style={{ cursor: 'pointer' }}
      />
      <p>{projectData.description.split('\n').map((line, index) => (
        <span key={index}>{line}<br /></span>
      ))}</p>
      <h2>Skills</h2>
      <ul>
        {projectData.skills.map((skill: string, index) => (
          <li key={index}>
            {(skills_icons)[skill] || skill}
          </li>
        ))}
      </ul>
      {projectData.link && (
        <div className="btn" style={{"--clr": "#2dd9fe", "--clr-glow":"#00a3d5"} as  React.CSSProperties}>
            <a href={projectData.link}>See Live</a>
        </div>
      )}
      {projectData.video && (
        <video controls>
          <source src={projectData.video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
      {projectData.illustrations && projectData.illustrations.length > 0 && (
        <div className="illustrations">
          <h2>Captures</h2>
          {projectData.illustrations.map((illustration, index) => (
            <img 
              key={index} 
              src={illustration} 
              alt={`Illustration ${index + 1}`} 
              onClick={() => {
                setPhotoIndex(index + 1);
                setIsOpen(true);
              }}
              style={{ cursor: 'pointer' }}
            />
          ))}
        </div>
      )}
      {projectData.showcases && Object.keys(projectData.showcases).length > 0 && (
        <div className="showcases">
          <h2>Artworks</h2>
          {Object.entries(projectData.showcases).map(([title, showcase], index) => (
            <div key={index}>
              <h3>{title}</h3>
              <a href={showcase.link} target="_blank" rel="noopener noreferrer">
                <span>View</span> 
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </a>
              {showcase.picture && <img src={showcase.picture} alt={title} />}
            </div>
          ))}
        </div>
      )}

      <Lightbox
        open={isOpen}
        close={() => setIsOpen(false)}
        slides={images}
        index={photoIndex}
      />
    </div>
  );
};

export default ProjectDetail;